"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
var localization_1 = require("./components/localization");
function initialize(_a) {
    var localize = _a.localize;
    localization_1.initialize(localize);
}
exports.initialize = initialize;
